import ExtraName from './ExtraName';

export default ExtraName;
export { ExtraName };
